function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from '@/api/templatemessage.js';
export default {
  name: "TemplateMessageAddOrUpdate",
  data: function data() {
    return {
      isLoading: false,
      visible: false,
      isEdit: false,
      // 是否为编辑状态
      isSubmitCheck: false,
      // 标记是否触发了提交校验（用于显示手动校验提示）
      contentFieldList: [],
      // 解析后的字段列表：[{field: 'character_string1', comment: '订单编号'}, ...]
      mappingData: {},
      // 临时存储映射数据
      dataForm: {
        id: 0,
        type: '',
        name: '',
        content: '',
        freightTemplateId: '',
        status: '',
        mark: '',
        paramsMappingJson: '' // 映射JSON字段
      },
      dataRule: {
        mark: [{
          required: true,
          message: '请选择模板标识',
          trigger: 'change'
        }]
      },
      // mark对应的固定字段配置
      markFieldConfig: {
        paySuccess: [{
          key: 'orderId',
          label: '订单编号'
        }, {
          key: 'amount',
          label: '支付金额'
        }, {
          key: 'payTime',
          label: '支付时间'
        }],
        deliver: [{
          key: 'orderId',
          label: '订单编号'
        }, {
          key: 'expressName',
          label: '快递公司'
        }, {
          key: 'expressNo',
          label: '快递单号'
        }, {
          key: 'deliverTime',
          label: '发货时间'
        }],
        fulfillment: [{
          key: 'orderId',
          label: '订单编号'
        }, {
          key: 'deliveryPerson',
          label: '配送人'
        }, {
          key: 'deliveryPhone',
          label: '配送电话'
        }, {
          key: 'deliveryTime',
          label: '配送时间'
        }]
      }
    };
  },
  watch: {
    // 监听content变化，解析{{xxx.DATA}}字段和对应的中文注释
    'dataForm.content': function dataFormContent(val) {
      this.parseContentFields(val);
    },
    // 监听mark变化，初始化映射数据
    'dataForm.mark': function dataFormMark(val) {
      this.isSubmitCheck = false; // 切换mark时重置校验提示
      this.initMappingData(val);
    }
  },
  methods: {
    // 修复：兼容多种格式的解析逻辑（先解析带注释的，解析不到则只解析字段）
    parseContentFields: function parseContentFields(content) {
      if (!content) {
        this.contentFieldList = [];
        return;
      }

      // 步骤1：先尝试解析带注释的字段（原有逻辑）
      var regWithComment = /([^:\n]+)\s*[:：]\s*\{\{(\w+)\.DATA\}\}/g;
      var fieldList = [];
      var match;

      // 解析带注释的字段
      var _loop = function _loop() {
        var comment = match[1].trim() || ''; // 注释可能为空，兜底
        var field = match[2].trim() || '';
        if (field && !fieldList.some(function (item) {
          return item.field === field;
        })) {
          fieldList.push({
            field: field,
            comment: comment
          });
        }
      };
      while ((match = regWithComment.exec(content)) !== null) {
        _loop();
      }

      // 步骤2：如果带注释的解析为空，降级解析仅字段（兼容纯{{xxx.DATA}}格式）
      if (fieldList.length === 0) {
        var regOnlyField = /\{\{(\w+)\.DATA\}\}/g;
        var _loop2 = function _loop2() {
          var field = match[1].trim() || '';
          if (field && !fieldList.some(function (item) {
            return item.field === field;
          })) {
            fieldList.push({
              field: field,
              comment: ''
            }); // 注释为空
          }
        };
        while ((match = regOnlyField.exec(content)) !== null) {
          _loop2();
        }
      }
      this.contentFieldList = fieldList;
    },
    // 根据mark初始化映射数据
    initMappingData: function initMappingData(mark) {
      this.mappingData = {};
      if (!mark || !this.markFieldConfig[mark]) return;

      // 如果有已保存的映射数据，先解析
      if (this.dataForm.paramsMappingJson) {
        try {
          var savedMapping = JSON.parse(this.dataForm.paramsMappingJson);
          this.mappingData = savedMapping;
        } catch (e) {
          console.error('解析映射数据失败:', e);
        }
      }
    },
    // 获取当前mark对应的固定字段
    getMarkFields: function getMarkFields() {
      return this.markFieldConfig[this.dataForm.mark] || [];
    },
    handleDialogClose: function handleDialogClose() {
      this.isSubmitCheck = false; // 关闭弹窗重置校验提示
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate();
      }
      this.contentFieldList = [];
      this.mappingData = {};
    },
    init: function init(id) {
      var _this = this;
      this.isLoading = false;
      this.isSubmitCheck = false;
      this.dataForm.id = id || 0;
      this.isEdit = !!id; // 有id即为编辑状态
      this.visible = true;
      this.$nextTick(function () {
        if (_this.$refs.dataForm) {
          _this.$refs.dataForm.resetFields();
        }
        if (_this.dataForm.id === 0) {
          // 新增状态初始化
          _this.dataForm = {
            id: 0,
            type: '',
            name: '',
            content: '',
            freightTemplateId: '',
            status: '',
            mark: '',
            paramsMappingJson: ''
          };
          _this.contentFieldList = [];
          _this.mappingData = {};
        } else {
          // 编辑状态加载数据
          api.templatemessageDetailApi(id).then(function (res) {
            _this.dataForm = _objectSpread(_objectSpread({}, res), {}, {
              paramsMappingJson: res.paramsMappingJson || ''
            });
            // 解析content字段（包含注释）
            _this.parseContentFields(res.content);
            // 初始化映射数据
            _this.initMappingData(res.mark);
          });
        }
      });
    },
    // 手动校验所有映射字段（核心修复：替代ElementUI的prop校验）
    validateMappingFields: function validateMappingFields() {
      this.isSubmitCheck = true; // 触发手动校验提示显示
      var markFields = this.getMarkFields();
      var isValid = true;
      var errorMsg = '';

      // 1. 检查是否选择了mark
      if (!this.dataForm.mark) {
        isValid = false;
        errorMsg = '请先选择模板标识';
        this.$message.error(errorMsg);
        return isValid;
      }

      // 2. 检查是否有模板字段但未解析出内容（避免无选项可选）
      if (markFields.length > 0 && this.contentFieldList.length === 0) {
        isValid = false;
        errorMsg = '未从回复内容中解析出模板字段，请先检查回复内容格式是否正确';
        this.$message.error(errorMsg);
        return isValid;
      }

      // 3. 遍历所有需要映射的字段，检查是否为空
      var _iterator = _createForOfIteratorHelper(markFields),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;
          if (!this.mappingData[field.key] || this.mappingData[field.key] === '') {
            isValid = false;
            errorMsg = "\u8BF7\u9009\u62E9\u3010".concat(field.label, "\u3011\u5BF9\u5E94\u7684\u6A21\u677F\u5B57\u6BB5");
            // 只提示第一个未填的字段，避免刷屏
            this.$message.error(errorMsg);
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return isValid;
    },
    dataSubmit: function dataSubmit() {
      var _this2 = this;
      if (this.isLoading) return;
      this.isLoading = true;

      // 第一步：手动校验映射字段（核心修复：先做这个，避免触发ElementUI的prop报错）
      var mappingValid = this.validateMappingFields();
      if (!mappingValid) {
        this.isLoading = false;
        return;
      }

      // 第二步：校验基础字段（mark）
      this.$refs['dataForm'].validate(function (basicValid) {
        if (!basicValid) {
          _this2.isLoading = false;
          return;
        }

        // 第三步：所有校验通过，提交数据
        // 组装映射数据到paramsMappingJson
        _this2.dataForm.paramsMappingJson = JSON.stringify(_this2.mappingData);
        var submitData = _objectSpread({}, _this2.dataForm);
        if (_this2.dataForm.id) {
          // 编辑
          api.templatemessageUpdateApi(submitData).then(function (res) {
            _this2.visible = false;
            _this2.$message.success('修改成功!');
            _this2.$emit('refreshDataList');
          }).catch(function (e) {
            _this2.isLoading = false;
            _this2.$message.error('修改失败!');
          });
        } else {
          // 新增
          api.templatemessageCreateApi(submitData).then(function (res) {
            _this2.visible = false;
            _this2.$message.success('添加成功!');
            _this2.$emit('refreshDataList');
          }).catch(function (e) {
            _this2.isLoading = false;
            _this2.$message.error('添加失败!');
          });
        }
      });
    }
  }
};